// オペレーション履歴タブ (AC-BSP-038) のフィルタの保持 (AC-SC-031、 #12745)。 約定結果タブとは別の key で持つ。
import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { Side } from '@ebalance/proto/bfftypes/v1/side_pb'

import { JEPX_AREA_CODES } from '~/models/area'
import { defineFilterCodec, oneOf } from '~/models/filterCodec'

import {
  EMPTY_OPERATION_HISTORY_FILTER,
  OPERATION_HISTORY_BID_KINDS,
  OPERATION_HISTORY_OPERATIONS,
  type OperationHistoryFilter,
} from './operationHistory'
import { readonlySetOf } from './readonlySetField'

export const SPOT_OPERATION_HISTORY_FILTER_STORAGE_KEY =
  'ebalance-spot-operation-history-filters'

export const operationHistoryFilterCodec =
  defineFilterCodec<OperationHistoryFilter>({
    defaults: () => EMPTY_OPERATION_HISTORY_FILTER,
    fields: {
      kinds: readonlySetOf(oneOf(OPERATION_HISTORY_BID_KINDS)),
      operations: readonlySetOf(oneOf(OPERATION_HISTORY_OPERATIONS)),
      // 業務エリアで外すのは表示する時 (約定結果タブと同じ `keepSelectableAreas`)
      areas: readonlySetOf(oneOf<AreaCode>(JEPX_AREA_CODES)),
      sides: readonlySetOf(oneOf<Side>([Side.BUY, Side.SELL])),
    },
  })
